import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ActivatedRouteSnapshot } from '@angular/router';
import { NavigationService } from 'src/services/navigation/navigation.service';

@Injectable({
	providedIn: 'root'
})
export class NavigationResolver  {
	// TODO: Der Ansatz mit dem Resolver ist kacke - sollte anders und besser gehen
	constructor(private navigationService: NavigationService) {
	}

	resolve(route: ActivatedRouteSnapshot): Observable<void> {
		return this.navigationService.getNavigation();
	}

}
